import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingComponent } from './loading.component';
import { LoadingService } from './loading.service';
import { LoadingConfig, LOADING_DEFAULT_CONFIG, loaddingDefaultConfig } from './loading.config';

// export function loadingFactory(app: ApplicationRef, cfr: ComponentFactoryResolver, injector: Injector) {
//     return new LoadingService(app, cfr, injector);
// }

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        LoadingComponent
    ],
    entryComponents: [
        LoadingComponent
    ]
})
export class LoadingModule {
    static forRoot(config?: LoadingConfig): ModuleWithProviders {
        // const _config = config ? Object.assign({}, loaddingDefaultConfig, config) : loaddingDefaultConfig;

        return {
            ngModule: LoadingModule,
            providers: [
                { provide: LOADING_DEFAULT_CONFIG, useValue: config || loaddingDefaultConfig},
                LoadingService
                // { provide: LoadingService, useFactory: loadingFactory, deps: [ApplicationRef, ComponentFactoryResolver, Injector] }
            ]
        };
    }
}
